export enum ScopeType {
  SCOPE_BY_WORK = 'SCOPE_BY_WORK',
  SCOPE_BY_SCENARIO = 'SCOPE_BY_SCENARIO',
  SCOPE_BY_ROLE = 'SCOPE_BY_ROLE',
}
